import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { IOrganization } from "types/organizationTypes"

interface OrganizationState {
  organizations: Array<IOrganization>
  currentOrganization: IOrganization | undefined
}

// Define the initial state using that type
const initialState: OrganizationState = {
  organizations: [] as IOrganization[],
  currentOrganization: undefined,
}

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setCurrentOrganization: (state, action: PayloadAction<IOrganization>) => {
      state.currentOrganization = action.payload
    },
    setOrganizations: (state, action: PayloadAction<Array<IOrganization>>) => {
      state.organizations = action.payload
    },
    addOrganization: (state, action: PayloadAction<IOrganization>) => {
      state.organizations?.push(action.payload)
    },
    updateOrganization: (state, action: PayloadAction<IOrganization>) => {
      var index = state.organizations.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.organizations[index] = action.payload
      }
    },
    resetOrganization: (state, _action) => {
      state.organizations = []
      state.currentOrganization = undefined
    },
  },
})

export const {
  setCurrentOrganization,
  setOrganizations,
  addOrganization,
  updateOrganization,
  resetOrganization,
} = organizationSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.organization

export default organizationSlice.reducer
